import * as Common from "../../commons/common"

export class Sheet {
  id: number
  nendo: number
  month: string
  grade: string
  kind: string
  sheet_name: string
  curriculum_name: string
  subject_name: string

  constructor(x: any){
    this.id = x.id;
    this.nendo = x.nendo;
    this.month = Common.formatDate(x.exec_date, "M");
    this.grade = Common.GetGradeNameByGrade(x.grade);
    this.kind = Common.GetKindNameByKind(x.kind);
    this.sheet_name = x.sheet_name;
    this.curriculum_name = x.at_curriculum_name;
    this.subject_name = x.at_subject_name;
  }

}